import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';
import { replace } from "connected-react-router";

import userRepository from "../../user/repositories/UserRepository";
import { currentUserSelector, isCurrentUserLoggedSelector } from '../../auth/store/auth-user/selectors';
import { setCurrentUserInfo } from "../../auth/store/auth-user/actions";

const namespace = 'ACCOUNT';

export const saveInfoRequest = createAction(`${namespace}/SAVE_INFO_REQUEST`);
export const saveInfoSuccess = createAction(`${namespace}/SAVE_INFO_SUCCESS`);
export const saveInfoFailed = createAction(`${namespace}/SAVE_INFO_FAILED`);

export function updateProfileInfo(changes) {
  return (dispatch, getState) => {

    const user = currentUserSelector(getState());
    const isLogged = isCurrentUserLoggedSelector(getState());
    if (isLogged) {
      dispatch(saveInfoRequest(user));

      userRepository.saveProfileInfo(user, changes)
        .then((updatedUser) => {
          dispatch(batchActions([
            saveInfoSuccess(updatedUser),
            setCurrentUserInfo(updatedUser)
          ]));
        })
        .catch((error) => dispatch(saveInfoFailed(error)));
    }
  }
}

export function saveInitialProfileInfo(info) {
  return (dispatch, getState) => {
    const user = currentUserSelector(getState());

    let stickerId;
    if (localStorage) {
      stickerId = localStorage.getItem('confStickerId');
      localStorage.setItem('confStickerId', '');
    }

    userRepository.saveProfileInfo(user, info)
      .then((updatedUser) => {
        dispatch(batchActions([
          saveInfoSuccess(updatedUser),
          setCurrentUserInfo(updatedUser),
        ]));
      })
      .catch((error) => {
        dispatch(saveInfoFailed(error))
      })
      .finally(() => {
        if (stickerId) { window.location.href = `${window.location.origin}/${stickerId}`; }
        else { dispatch(replace('/')); }
      });
  };
}